import React from 'react';
import PropTypes from 'prop-types';

function ExperienceEntry({ role, lang }) {
  const entryClass = role.current
    ? 'App-experience-entry is-current'
    : 'App-experience-entry';

  return (
    <li className={entryClass}>
      <h3 className="App-experience-title">
        {role.title}
        {role.current && (
          <span className="App-experience-current">
            {lang === 'en' ? 'Current' : 'Atual'}
          </span>
        )}
      </h3>
      <p className="App-experience-employer">{role.employer}</p>
      <p className="App-experience-meta">
        {role.period} · {role.arrangement}
      </p>
      <p className="App-experience-location">{role.location}</p>
      <p className="App-experience-context">{role.context}</p>
      <ul className="App-experience-accomplishments">
        {role.accomplishments.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    </li>
  );
}

ExperienceEntry.propTypes = {
  role: PropTypes.shape({
    title: PropTypes.string.isRequired,
    employer: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    arrangement: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    context: PropTypes.string.isRequired,
    accomplishments: PropTypes.arrayOf(PropTypes.string).isRequired,
    current: PropTypes.bool,
  }).isRequired,
  lang: PropTypes.oneOf(['en', 'pt-BR']).isRequired,
};

export default ExperienceEntry;
